import { render } from "./BaseLoading.vue?vue&type=template&id=70e3294c&scoped=true"
import script from "./BaseLoading.vue?vue&type=script&lang=js"
export * from "./BaseLoading.vue?vue&type=script&lang=js"

import "./BaseLoading.vue?vue&type=style&index=0&id=70e3294c&scoped=true&lang=css"

import exportComponent from "/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70e3294c"]])

export default __exports__